var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"filepond-el"}})
}
var staticRenderFns = []

export { render, staticRenderFns }